import _ from 'underscore';
import Backbone from 'backbone';

export var CUCounter = Backbone.Model.extend({
  url: 'cu',

  initialize: function () {
    this.unregister = _.noop;
    this.resetTimer = _.noop;

    _.bindAll(this, 'startPolling', 'stopPolling');
  },

  parse: function (res) {
    return {
      count: res.result
    };
  },

  startPolling: function (game, seconds, maxCall) {
    var timeout;
    var ms = seconds * 1000;

    this.stopPolling().fetch({ game: game });
    this.unregister = _.repeat(_.bind(this.fetch, this, { game: game }), ms);

    if (_.isNumber(maxCall)) {
      timeout = (maxCall - 1) * ms;
      this.resetTimer = _.delayed(_.bind(this.unregister, this), timeout);
    }
  },

  stopPolling: function () {
    this.unregister();
    this.resetTimer();
    return this;
  }
});
